




import { Component, Vue, Prop } from 'vue-property-decorator';
import { ApprovalHistory } from '@/models/approval-history';

@Component
export default class ApprovalHistoryDescription extends Vue {
    @Prop({ required: true }) public entry: ApprovalHistory;

    public get description(): string {
        switch (this.entry.name) {
        case 'ApprovalRejected':
            return `Approval rejected by ${this.entry.generatedBy}`;
        case 'ApprovalAccepted':
            return `Approval accepted by ${this.entry.generatedBy}`;
        case 'ApprovalCreated':
            return `Approval generated for quote '${this.entry.data.quoteId}'`;
        default:
            return `${this.entry.name}`;
        }
    }
}
